import type { NotificationsStreamEvent } from '@d-orca/shared/client/apis';
import { SseChannel, siteStreamUrl, userStreamUrl, type ISseChannelHandlers } from './sseChannel';

// Browser-side client for `/api/notifications/stream` — the signed-in person's
// own stream, open on every page. The connection machinery lives in
// `SseChannel`; the frames are the shared `NotificationsStreamEvent`.
//
// A signal frame is not a payload: it says the person's notifications
// changed, and in which site, and the bell asks the server again. The stream
// never carries a count, so what the app shows cannot disagree with the server.
//
// Opened for a site, it is that site's stream: the same signals, plus the
// person's alerts there, relayed from the engine as whole frames (alerts
// spec, D2) — there is no list of alerts to ask for.

export type NotificationsStreamHandlers = ISseChannelHandlers<NotificationsStreamEvent>;

export class NotificationsStream {
  private readonly channel: SseChannel<NotificationsStreamEvent>;

  constructor(siteId: string | null, handlers: NotificationsStreamHandlers) {
    const url = siteId ? siteStreamUrl(siteId, 'notifications/stream') : userStreamUrl('notifications/stream');
    this.channel = new SseChannel(url, handlers);
  }

  open(): void {
    this.channel.open();
  }

  close(): void {
    this.channel.close();
  }
}
